import { useMemo } from 'react';
import type { Project } from '@soc/shared';
import { useGetProjectsQuery } from '../../app/api';
import { useAppSelector } from '../../app/hooks';

/**
 * The currently-active project (or undefined if none selected / not yet loaded).
 * Detection and data queries are scoped to its polygon.
 */
export function useSelectedProject(): Project | undefined {
  const selectedId = useAppSelector((s) => s.projects.selectedId);
  const { data } = useGetProjectsQuery();
  return useMemo(
    () => data?.items.find((p) => p.id === selectedId),
    [data, selectedId],
  );
}
